/**
 * A simple converter for turning past Unix timestamps into a readable phrase (e.g. "4 minutes ago").
 * @param {BigInteger} time - A Unix timestamp, from the past, in milliseconds
 * @returns {String}
 */
// Another interesting example using recursion here: https://gist.github.com/boxnos/5896114
// If a more robust solution is needed, take a look at https://github.com/hustcc/timeago.js
export function timeAgoInWords(time) {
  // Convert time and the time right now to seconds
  const now = Math.floor(Date.now() / 1000);
  const then = Math.floor(time / 1000);

  // Is this set up wrong? Each value in the array is actually referencing the previous item. For instance, there are 24 hours in a day.
  const timeUnits = [
    ["minute", 60],
    ["hour", 60],
    ["day", 24],
    // ["week", 7]
    ["month", 30],
    ["year", 12]
  ];

  // Difference between then and now in seconds
  const diff = now - then;

  // Return null if the `time` is in the future
  if (diff < 0) return null;

  // Set mutable value for the current units (seconds)
  let currentUnits = diff;

  for (let i = 0; i < timeUnits.length; i++) {
    const isLast = i + 1 === timeUnits.length;
    const key = timeUnits[i][0];
    const val = timeUnits[i][1];
    const nextVal = isLast ? 0 : timeUnits[i + 1][1];

    currentUnits = Math.floor(currentUnits / val);

    if (currentUnits < nextVal || isLast) {
      // Add plural to key if our end value is greater than 1
      if (currentUnits < 1) return "Now";
      const label = currentUnits > 1 ? key + "s" : key;
      return `${currentUnits} ${label} ago`;
    }
  }
}
